<div class="page-layout carded left-sidenav toolbar-fixed-layout">
  <div class="toolbar second-level-toolbar flex flex-row justify-between items-center">
    <div class="flex flex-col justify-center items-start grid-toolbar-buttons-group-container w-p-100">
      <particle-breadcrumbs [breadcrumbs]="breadcrumbs"
                            (selectionChanged)="onBreadcrumbSelectionChanged($event)"
                            disableNavigation="true"
      >
      </particle-breadcrumbs>
    </div>
  </div>
  <div class="toolbar second-level-toolbar flex flex-row justify-between items-center">
    <div class="flex flex-col justify-center items-start grid-toolbar-buttons-group-container"
         [style.visibility]="isTaskVisible? 'visible': 'hidden'"
    >
      <label class="component-label">Actions</label>
      <div class="grid-toolbar-buttons-group flex flex-row justify-start items-center">
        <div class="button-container flex flex-row justify-start items-center">
          <button mat-button class="orbitax-flat-button" (click)="openAddTaskDialog()"
                  particleAnalytics
                  analyticsCategory="file-manager-content"
                  analyticsAction="Add-Folder">Add Task
          </button>
          <div class="toolbar-separator"></div>
        </div>
      </div>
    </div>
  </div>
  <mat-sidenav-container>
    <!-- CENTER -->
    <div class="center">
      <!-- CONTENT CARD -->
      <div class="content-card mat-white-bg">

        <div class="content pos-relative m-l-30 m-r-30 m-b-30 flex flex-col">
          <div class="keno-grid-container">
            <particle-virtual-grid
              [style.display]="!isTaskVisible? '':'none'"
              [sourceKey]="sourceKey"
              (valueChanged)="onGridCellValueChange($event)"
              (selectionChanged)="onSelectionChanged($event)"
              sortFieldKey="Title"
              [invalidateSubject]="invalidateSubjectBoardList"
              tag="TaskSelector">
            </particle-virtual-grid>
            <particle-virtual-grid
              [style.display]="isTaskVisible? '':'none'"
              [sourceKey]="sourceKeyTickets"
              (valueChanged)="onGridCellValueChange($event)"
              (selectionChanged)="onSelectionChanged($event)"
              sortFieldKey="Title"
              [invalidateSubject]="invalidateSubjectTaskList"
              showSelectAll="'true'">
            </particle-virtual-grid>
          </div>
        </div>
      </div>
    </div>
  </mat-sidenav-container>
</div>
